<template>
  <van-row class="page-wrapper" justify="center">
    <!-- Используем наш новый компонент списка -->
    <indications-history-list />
  </van-row>
</template>

<script>
// Импортируем новый компонент
import IndicationsHistoryList from "@/components/history/IndicationsHistoryList";

export default {
  name: "IndicationsHistory",
  // Регистрируем его
  components: { IndicationsHistoryList },
};
</script>
